module.exports = __webpack_public_path__ + "img/btn-next.623d431f.svg";